import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Plus, SearchIcon, ChevronDown, X } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import Swal from "sweetalert2";
import Select from "react-select";

import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import RegisterPoisonFactorycolumns from "Common/Components/ColumnData/RegisterPoisonFactorycolumns";

const RegisterPoisonFactory = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [dataFactoryValue, setdataFactoryValue] = useState<any>();
  const [dataListFatory, setdataListFatory] = useState<any>();
  const [poison, setpoison] = useState<any>();
  const [poisonValue, setpoisonValue] = useState<any>();
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const localstorageID = localStorage.getItem("crop_year_id");
  const [isLoadingBtn, setisLoadingBtn] = useState<Boolean>(false);
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [isEdit, setisEdit] = useState<any>(false);
  const [DataID, setDataID] = useState<any>(false);
  const [FactoryNmeEdit, setFactoryNmeEdit] = useState<any>(false);
  const [SamEdit, setSamEdit] = useState<any>(false);
  const [SearchValuePoison, setSearchValuePoison] = useState<any>(null);
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  const sortLabels: any = {
    amount: "مقدار",
    unit_name: "واحد",
    factory_price: "قیمت کارخانه",
    farmer_price: "قیمت کشاورز",
  };
  useEffect(() => {
    const localStorageID = localStorage.getItem("crop_year_id"); // تصحیح نام متغیر

    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.havirkesht.ir/crop-year/"
        );
        const getyear = response?.data?.items?.find(
          (item: any) => item.id == localStorageID // تصحیح نام متغیر
        );
        setYearCoptSelect(getyear?.crop_year_name || "");
      } catch (error) {
        console.error("Error fetching crop year data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const getFactory = async () => {
      try {
        const token = localStorage.getItem("app_atkey");

        const response = await axios.get(`https://api.havirkesht.ir/factory/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setdataListFatory(response.data?.items || []);
      } catch (error) {
        console.error("Error fetching factory data:", error);
      }
    };
    getFactory();
  }, [show]);

  useEffect(() => {
    const fetchData = async () => {

      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/pesticide/`;
        if (SearchValuePoison && SearchValuePoison.trim() !== "") {
          url += `?search=${encodeURIComponent(SearchValuePoison.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        setpoison(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [SearchValuePoison]);

  const fetchDataFactoryPesticide = async () => {
    setload(true);
    setData(null);
    try {
      let url = `https://api.havirkesht.ir/factory_pesticide/?&crop_year_id=${localstorageID}`;
      if (sortState.name) {
        if (sortState.step === 2) {
          url += `&sort_by=${sortState.name}&sort_order=desc`;
        } else {
          url += `&sort_by=${sortState.name}&sort_order=${sortState.order}`;
        }
      }
      if (searchQuery && searchQuery.trim() !== "") {
        url += `&search=${encodeURIComponent(searchQuery.trim())}`;
      }
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      const items = res?.data?.items || [];
      setData(items);
      setload(items.length <= 0);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setErrorMessage(
        error?.message ? "" : "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
      );
      setload(true);
    }
  };
  useEffect(() => {
    fetchDataFactoryPesticide();
  }, [reload, searchQuery, sortState]);

  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const onClickUpdate = (cell: any) => {
    setShow(true);
    setisEdit(true);
    console.log(cell);
    setEventData(cell);
    setdataFactoryValue(cell?.factory_id);
    setpoisonValue(cell?.pesticide_id); // اضافه شده
    validation.setFieldValue("amount", cell?.amount || "");
    validation.setFieldValue("priceFarmer", cell?.farmer_price || 0);
    validation.setFieldValue("priceFactory", cell?.factory_price || 0);
    setFactoryNmeEdit(cell?.factory_name);
    setSamEdit(cell?.pesticide_name);
    setDataID(cell.id);
  };

  const handleDelete = async () => {
    if (eventData) {
      const res = await axios.delete(
        `https://api.havirkesht.ir/factory_pesticide/${eventData}`
      );
      if (res.status === 200) {
        Swal.fire({
          title: "حذف سم کارخانه",
          text: "عملیات حذف با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      } else {
        Swal.fire({
          title: "حذف سم کارخانه",
          text: "مشکلی در حذف به وجود امده است",
          icon: "success",
        });
      }

      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: isEdit ? eventData?.amount || "" : "",
      priceFarmer: isEdit ? eventData?.farmer_price || 0 : 0,
      priceFactory: isEdit ? eventData?.factory_price || 0 : 0,
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("لطفاً تعداد را وارد کنید"),
      priceFarmer: Yup.number().required("لطفاً قیمت کشاورز را وارد کنید"),

      priceFactory: Yup.number().required("لطفاً قیمت کارخانه را وارد کنید"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        if (!dataFactoryValue || !poisonValue) {
          setShow(true);
          toast.error("لطفاً کارخانه و سم را انتخاب کنید");
          return;
        }

        setisLoadingBtn(true);
        const requestData = {
          amount: Number(values.amount),
          farmer_price: Number(values.priceFarmer ? values.priceFarmer : 0),
          factory_price: Number(values.priceFactory ? values.priceFactory : 0),
          factory_id: Number(dataFactoryValue),
          pesticide_id: Number(poisonValue),
          crop_year_id: Number(localStorage.getItem("crop_year_id")),
        };
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
          },
        };

        const response = isEdit
          ? await axios.put(
              `https://api.havirkesht.ir/factory_pesticide/${DataID}`,
              requestData,
              config
            )
          : await axios.post(
              "https://api.havirkesht.ir/factory_pesticide/",
              requestData,
              config
            );

        if ([200, 201].includes(response?.status)) {
          await Swal.fire({
            title: isEdit ? "ویرایش سم کارخانه" : "ثبت سم کارخانه",
            text: "عملیات با موفقیت انجام شد",
            icon: "success",
          });
          setisEdit(false);
          setreload((prev) => !prev);
          resetForm();
          setpoisonValue(null);
          setdataFactoryValue(null);
        }
      } catch (error: any) {
        if (error.status === 409) {
          resetForm();
          setpoisonValue(null);
          setdataFactoryValue(null);
          setShow(true);
          return Swal.fire({
            title: "اطلاعات قبلا ثبت شده",
            text: "اطلاعات مربوط به کارخانه ، سم  و سال زراعی  قبلاً ثبت شده و امکان ثبت مجدد وجود ندارد     .",
            icon: "warning",
          });
        }
        console.error("Error:", error);
        await Swal.fire({
          title: "خطا",
          text:
            error.response?.data?.message ||
            "خطایی در انجام عملیات رخ داده است",
          icon: "error",
        });
      } finally {
        setisLoadingBtn(false);
        toggle();
      }
    },
  });
  const formatNumber = (num: number | string) => {
    if (!num) return "";
    const numStr = num.toString().replace(/,/g, "");
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum.replace(/,/g, "");
  };

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setisEdit(isEdit ? false : isEdit);
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const onclickSort = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name: "created_at", order: "desc", step: 2 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        // اگر ستون جدیدی انتخاب شد
        return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
      }
    });
    setreload(!reload);
  };
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  const columns = RegisterPoisonFactorycolumns({
    onClickDelete,
    onClickUpdate,
    onclickSort,
  });

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت سم کارخانه" title="هاویر کشت" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body ">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع سم کارخانه (<b className="total-Employs">{data?.length}</b>)
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جستجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <SearchIcon
                    size={15}
                    className="absolute inset-y-0 top-2 left-2 flex items-center text-gray-400"
                  />
                </div>
              </label>
            </h6>
            <div className="shrink-0">
              <Link
                to="#!"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl"> ثبت سم کارخانه </span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${
                    sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                  }`}
            </div>
          )}
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={10}
              customPageSize={10}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16"> ثبت سم کارخانه </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                <div className="flex flex-col items-center space-y-4 w-full max-w-md mx-auto">
                  <div className="flex items-center w-full gap-2">
                    <label
                      htmlFor="seed"
                      className="text-base font-medium w-24 flex-shrink-0 text-gray-700 dark:text-gray-300"
                    >
                      سم:
                    </label>
                    <div className="relative flex-1 z-50">
                      <Select
                        // value={
                        //   poisonValue == null
                        //     ? null
                        //     : poison?.find((item: any) => item.id === poison)
                        //     ? {
                        //         value: poisonValue,
                        //         label: dataListFatory.find(
                        //           (item: any) => item.id == poisonValue
                        //         ).pesticide_name,
                        //       }
                        //     : null
                        // }
                        value={
                          poisonValue === null
                            ? null
                            : poison?.find(
                                (item: any) => item.id === poisonValue
                              )
                            ? {
                                value: poisonValue,
                                label: poison.find(
                                  (item: any) => item.id === poisonValue
                                ).pesticide_name,
                              }
                            : null
                        }
                        options={poison?.map((item: any) => ({
                          value: item.id,
                          label: item.pesticide_name,
                        }))}
                        onChange={(selected: any) => {
                          // setSelectedPoison(selected);
                          setpoisonValue(selected?.value);
                        }}
                        onInputChange={(inputValue) => {
                          setSearchValuePoison(inputValue);
                        }}
                        menuPortalTarget={document.body}
                        placeholder="انتخاب..."
                        noOptionsMessage={() => "داده‌ای دریافت نشد"}
                        loadingMessage={() => "در حال بارگذاری..."}
                        className="w-full my-react-select-container"
                        classNamePrefix="my-react-select"
                        maxMenuHeight={300}
                        isSearchable
                        menuPlacement="auto"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base, state) => ({
                            ...base,
                            backgroundColor: "inherit",
                            boxShadow: state.isFocused
                              ? "0 0 0 1px #2684FF"
                              : "none",
                          }),
                          option: (base, state) => ({
                            ...base,
                            color: "inherit",
                            "&:hover": {
                              backgroundColor: "#2684FF",
                            },
                          }),
                        }}
                        menuShouldScrollIntoView={false}
                      />
                      {isEdit && (
                        <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg space-y-3">
                          <div className="flex items-center space-x-4">
                            <span className="font-medium">
                              ✅ سم انتخاب شده :
                            </span>
                            <span className="px-1">{SamEdit || "-"}</span>
                          </div>
                        </div>
                      )}
                      <div className="absolute inset-y-0 left-2 flex items-center pointer-events-none">
                        {!isEdit && <ChevronDown />}
                      </div>
                    </div>
                  </div>

                  {/* کارخانه */}
                  <div className="flex items-center w-full gap-2">
                    <label
                      htmlFor="factory"
                      className="text-base font-medium w-24 flex-shrink-0 text-gray-700 dark:text-gray-300"
                    >
                      کارخانه:
                    </label>
                    <div className="relative flex-1">
                      <Select
                        value={
                          dataFactoryValue === null
                            ? null
                            : dataListFatory?.find(
                                (item: any) => item.id === dataFactoryValue
                              )
                            ? {
                                value: dataFactoryValue,
                                label: dataListFatory.find(
                                  (item: any) => item.id === dataFactoryValue
                                ).factory_name,
                              }
                            : null
                        }
                        options={dataListFatory?.map((item: any) => ({
                          value: item.id,
                          label: item.factory_name,
                        }))}
                        onChange={(selectedValue: any) =>
                          setdataFactoryValue(selectedValue.value)
                        }
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base, state) => ({
                            ...base,
                            backgroundColor: "inherit",
                            boxShadow: state.isFocused
                              ? "0 0 0 1px #2684FF"
                              : "none",
                          }),
                          option: (base, state) => ({
                            ...base,
                            color: "inherit",
                            "&:hover": {
                              backgroundColor: "#2684FF",
                            },
                          }),
                        }}
                        menuPortalTarget={document.body}
                        placeholder="انتخاب..."
                        noOptionsMessage={() => "داده‌ای دریافت نشد"}
                        loadingMessage={() => "در حال بارگذاری..."}
                        className="w-full my-react-select-container"
                        classNamePrefix="my-react-select"
                        maxMenuHeight={300}
                        isSearchable
                      />
                      {isEdit && (
                        <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg space-y-3">
                          <div className="flex items-center space-x-4">
                            <span className="font-medium">
                              ✅ کارخانه انتخاب شده :
                            </span>
                            <span className="px-1">
                              {FactoryNmeEdit || "-"}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="absolute inset-y-0 left-2 flex items-center pointer-events-none">
                        {!isEdit && <ChevronDown />}
                      </div>
                    </div>
                  </div>
                  {/* تعداد */}

                  <div className="flex items-center w-full gap-2">
                    <label
                      htmlFor="amount"
                      className="text-base font-medium w-24 flex-shrink-0 text-gray-700 dark:text-gray-300"
                    >
                      تعداد:
                    </label>
                    <input
                      type="number"
                      id="amount"
                      name="amount"
                      className="flex-1 p-2 border border-gray-300 rounded-lg bg-white text-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      placeholder="تعداد را وارد کنید"
                      onChange={validation.handleChange}
                      value={validation.values.amount}
                    />
                  </div>

                  {validation.touched.amount && validation.errors.amount && (
                    <p className="text-red-500 text-sm mt-1 w-full text-left pl-24">
                      {validation.errors.amount as string}
                    </p>
                  )}

                  {/* قیمت کارخانه */}
                  <div className="flex items-center w-full gap-2">
                    <label
                      htmlFor="priceFactory"
                      className="text-base font-medium w-24 flex-shrink-0 text-gray-700 dark:text-gray-300"
                    >
                      قیمت کارخانه:
                    </label>
                    <input
                      type="text" // نوع را به text تغییر دهید
                      id="priceFactory"
                      name="priceFactory"
                      className="flex-1 p-2 border border-gray-300 rounded-lg bg-white text-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300
      focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      placeholder="قیمت کارخانه را وارد کنید"
                      onChange={(e) => {
                        const value = parseFormattedNumber(e.target.value);
                        validation.setFieldValue("priceFactory", value);
                      }}
                      value={formatNumber(validation.values.priceFactory)}
                    />
                  </div>

                  {/* قیمت کشاورز */}
                  <div className="flex items-center w-full gap-2">
                    <label
                      htmlFor="priceFarmer"
                      className="text-base font-medium w-24 flex-shrink-0 text-gray-700 dark:text-gray-300"
                    >
                      قیمت کشاورز:
                    </label>
                    <input
                      type="text" // نوع را به text تغییر دهید
                      id="priceFarmer"
                      name="priceFarmer"
                      className="flex-1 p-2 border border-gray-300 rounded-lg bg-white text-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300
      focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      placeholder="قیمت کشاورز را وارد کنید"
                      onChange={(e) => {
                        const value = parseFormattedNumber(e.target.value);
                        validation.setFieldValue("priceFarmer", value);
                      }}
                      value={formatNumber(validation.values.priceFarmer)}
                    />
                  </div>
                </div>
                <div className="">
                  سال زراعی انتخاب شده:
                  <span className="text-custom-600 dark:text-gray-200 bold">
                    {YearCoptSelect ? YearCoptSelect : ""}{" "}
                  </span>{" "}
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            {isLoadingBtn
              ? "در حال ارسال..."
              : isEdit
              ? "بروزرسانی اطلاعات"
              : "ثبت اطلاعات"}{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default RegisterPoisonFactory;
